import Qlik from './components/Qlik';

export default {
	component: Qlik
};